import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getfloorData } from "../store/actions/floorActions";

const Select = ({ options, onChange, id }) => {
  // ... rest of original code
};

export default Select;
